// @ts-nocheck
class CustomLazyImage extends HTMLElement {
  constructor() {
    super();

    this.images = this.querySelectorAll('img');
    if (this.images.length > 0) {
      if (this.images.length > 1) {
        // Multiple images - handle responsive behavior
        this.handleResponsiveImages();
        window.addEventListener('resize', () => this.handleResponsiveImages());
      } else {
        // Single image - use original behavior
        this.image = this.images[0];
        this.setupLazyLoading(this.image);
      }
    }
  }

  handleResponsiveImages() {
    const viewportWidth = window.innerWidth;
    let targetImage = null;

    if (viewportWidth <= 749) {
      // For mobile view, prioritize the non-small-hide image
      for (const img of this.images) {
        if (!img.classList.contains('small-hide')) {
          targetImage = img;
          break;
        }
      }
      // If no suitable image found, use the first one
      if (!targetImage) targetImage = this.images[0];
    } else {
      // For desktop view, prioritize the non-large-up-hide image
      for (const img of this.images) {
        if (!img.classList.contains('large-up-hide')) {
          targetImage = img;
          break;
        }
      }
      // If no suitable image found, use the first one
      if (!targetImage) targetImage = this.images[0];
    }

    // Update the active image
    if (this.image !== targetImage) {
      // Remove any existing observers from previous image
      if (this.observer && this.image) {
        this.observer.disconnect();
      }

      this.image = targetImage;
      this.setupLazyLoading(this.image);
    }
  }

  setupLazyLoading(image) {
    this.handleLazy();

    this.observer = new MutationObserver((changes) => {
      changes.forEach((change) => {
        if (change.attributeName.includes('src') || change.attributeName.includes('srcset')) {
          this.handleLazy();
        }
      });
    });
    this.observer.observe(image, { attributes: true });
  }

  handleLazy() {
    if (!this.image.complete) {
      this.parentNode.classList.add('loading');

      this.image.addEventListener(
        'load',
        () => {
          this.parentNode.classList.remove('loading');
        },
        false
      );
    }
  }
}
customElements.define('custom-lazy-image', CustomLazyImage);
